export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/b94cdee409f55382a26c8aa8c74f2625.png";